var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ad-card"},[_c('img',{staticClass:"ad-img",attrs:{"src":require("./images/index_bannel_img.png"),"alt":"侧边广告"}})])
}]

export { render, staticRenderFns }